import React from 'react';
import Serializer, {
  type SerializeArguments,
  type DeserializeArguments,
} from './Serializer';
import { type EmailVariableReferenceElement } from '../../types/aha-editor';
import { isHTMLElementNode } from '../helpers/serializerHelpers';
import { isEmailVariableReferenceElement } from '../../types/guards';

class SerializeEmailVariableReference extends Serializer {
  static deserialize({
    el,
    next,
    markAttributes,
  }: DeserializeArguments): EmailVariableReferenceElement | undefined {
    if (
      !isHTMLElementNode(el) ||
      el.tagName.toLowerCase() !== 'span' ||
      el.getAttribute('data-aha-editor-type') !== 'email-variable-reference'
    )
      return;

    return {
      type: 'email-variable-reference',
      variable_name: el.getAttribute('data-variable-name') || '',
      children: next(el.childNodes, markAttributes),
    };
  }

  static serialize({ node, children }: SerializeArguments): React.ReactNode {
    if (!isEmailVariableReferenceElement(node)) return;

    const { variable_name } = node;

    return (
      <span
        data-aha-editor-type="email-variable-reference"
        data-variable-name={variable_name}
      >
        {`[${variable_name}]`}
      </span>
    );
  }
}

export default SerializeEmailVariableReference;
